import { getWorksheetProviderProps } from 'Components/Worksheets/Core/WorksheetEditorInjectedPropsProvider';
import {
  WorksheetInjectedConsumerProps,
  WorksheetInjectedPropsModifier,
} from 'Components/Worksheets/Core/WorksheetEditorInjectedPropsProvider/types';
import { Guid } from 'Lib/Guid';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetGrid';
import { InjectedPropsProvider } from '../../../Core/InjectedPropsContext';

type WorksheetGridEntryInjectedPropsProviderProps = {
  worksheetId: Guid;
};

let WorksheetGridEntryInjectedPropsProvider: React.FC<
  React.PropsWithChildren<WorksheetGridEntryInjectedPropsProviderProps>
> = ({ children, worksheetId }) => {
  const dispatch = useDispatch();

  const locked = useSelector((state) => state.worksheetGrid.worksheets[worksheetId]?.status.readonly.locked);

  const getProviderProps = useCallback(
    (consumerProps: WorksheetInjectedConsumerProps, modifiers: Array<WorksheetInjectedPropsModifier>) =>
      getWorksheetProviderProps(
        consumerProps,
        {
          worksheetId,
          locked,
          setValue: (v: any) => dispatch(actions.setWorksheetValue({ ...v, worksheetId })),
          synchronise: () => dispatch(actions.synchroniseWorksheet({ worksheetId })),
          worksheetSelector: (state) => state.worksheetGrid.worksheets[worksheetId]?.syncModel,
          worksheetConfigSelector: (state) => state.worksheetGrid.worksheets[worksheetId]?.config,
          worksheetTypeSelector: (state) => state.worksheetGrid.worksheets[worksheetId]?.worksheetType,
        },
        modifiers
      ),
    [locked, worksheetId, dispatch]
  );

  return <InjectedPropsProvider getProviderProps={getProviderProps}>{children}</InjectedPropsProvider>;
};

export { WorksheetGridEntryInjectedPropsProvider };
export default WorksheetGridEntryInjectedPropsProvider;
